import {InjectionToken} from '@angular/core';

export const ENVIRONMENT_CONFIG_URL = new InjectionToken<string | undefined>(
  'ENVIRONMENT_CONFIG_URL'
);
